
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import ControlCollapse from './control-collapse'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "controlcollapse"
    }}>{`ControlCollapse`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Controls`}</p>
    <hr />
    <h2 {...{
      "id": "collapse"
    }}>{`Collapse`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For triggering a change in the interface in order to hide content.`}</p>
    <Playground __position={1} __code={'<ControlCollapse />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlCollapse
    }} mdxType="Playground">
  <ControlCollapse mdxType="ControlCollapse" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={2} __code={'<ControlCollapse disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlCollapse
    }} mdxType="Playground">
  <ControlCollapse disabled mdxType="ControlCollapse" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "collapse-disc"
    }}>{`Collapse (disc)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For triggering a change in the interface in order to hide content.
Useful in places where the control must overlap other objects.`}</p>
    <Playground __position={4} __code={'<ControlCollapse disc />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlCollapse
    }} mdxType="Playground">
  <ControlCollapse disc mdxType="ControlCollapse" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={5} __code={'<ControlCollapse disc disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlCollapse
    }} mdxType="Playground">
  <ControlCollapse disc disabled mdxType="ControlCollapse" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={ControlCollapse} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;